import Link from '@blackbird/ui-base/link';
import { Button, Container, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
    height: '100%',
  },
  grid: {
    alignSelf: 'center',
    textAlign: 'left',
  },
  getStartedImage: {
    width: '100%',
    borderRadius: '10px',
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

export default function GettingStartedPage() {
  const { classes } = useStyles();
  const { t } = useTranslation(['shared', 'gettingStarted']);

  return (
    <div className={classes.root}>
      <Grid container className={classes.grid}>
        <Grid item xs={12} sm={6}>
          <Container>
            <img className={classes.getStartedImage} src="/images/getting-started.png" />
          </Container>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.grid}>
          <Container>
            <Typography variant="h3" align="left">
              {t(['gettingStarted:liveDataAnywhere'], {
                defaultValue: 'Live data, anywhere',
              })}
            </Typography>
            <Typography variant="subtitle1" align="left">
              {t(['gettingStarted:letsUsGuideYou'], {
                defaultValue: 'First time using Blackbird? Let us guide you through it.',
              })}
            </Typography>
            <Link
              href={{
                pathname: '/getting-started/learn',
              }}
            >
              <Button variant="contained" color="primary" className={classes.button}>
                {t(['gettingStarted:getStarted'], {
                  defaultValue: 'Get Started',
                })}
              </Button>
            </Link>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
